import { getHasCreatedEmailsEarlyRequest, removeHasCreatedEmailsEarlyRequest } from 'email-management-lib/EarlyRequest/utils';
import makeGlobalStateHook from 'messaging-management-lib/data/makeGlobalStateHook';
import { useEffect } from 'react';
const hasCreatedEmailsRequest = new Promise((resolve, reject) => {
  var _getHasCreatedEmailsE, _getHasCreatedEmailsE2;
  if (getHasCreatedEmailsEarlyRequest() === null) {
    reject(new Error('No early request found'));
  }
  (_getHasCreatedEmailsE = getHasCreatedEmailsEarlyRequest()) === null || _getHasCreatedEmailsE === void 0 || _getHasCreatedEmailsE.onError(error => reject(error));
  (_getHasCreatedEmailsE2 = getHasCreatedEmailsEarlyRequest()) === null || _getHasCreatedEmailsE2 === void 0 || _getHasCreatedEmailsE2.whenFinished(response => {
    resolve(response.totalCount > 0);
    removeHasCreatedEmailsEarlyRequest();
  });
});
// Prevent the error from bubbling up in the global context
hasCreatedEmailsRequest.catch(() => null);
const useRequestState = makeGlobalStateHook();
export default function useEmptyState() {
  const [requestState, setRequestState] = useRequestState({
    hasCreatedEmails: false,
    isLoading: true
  });
  useEffect(() => {
    hasCreatedEmailsRequest.then(result => setRequestState({
      hasCreatedEmails: result,
      isLoading: false
    })).catch(() => setRequestState({
      hasCreatedEmails: true,
      isLoading: false
    }));
  }, [setRequestState]);
  return {
    loading: requestState.isLoading,
    shouldRender: !requestState.hasCreatedEmails
  };
}